

































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { get_agency_invoice_detail } from '@/api/invoice';
import { formatTime } from '@/utils/index';

@Component({
  name: 'InvoiceAgencyDetailOperationLogs',
})
export default class extends Vue {
  @Prop({ default: true }) flat!: boolean;
  @Prop({ default: true }) title!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true }) logs!: get_agency_invoice_detail.OperationLog[];

  get translatedHeaders() {
    return [
      { text: this.$t('Operated by'), value: 'operator' },
      {
        text: this.$t('Timestamp'),
        value: 'timestamp',
      },
      { text: this.$t('Content'), value: 'operation' },
      { text: this.$t('Note'), value: 'note' },
    ];
  }

  private getTimestampText(timestamp: string) {
    return formatTime(new Date(timestamp));
  }
}
